import {actionMergeSetting, updateSetting} from "../../../redux/settings/settingsAction";

function mapDispatchToProps(dispatch){
    return {
        mergeSettings:(change)=>dispatch(actionMergeSetting(change)),
        updateSettings:(change)=>dispatch(updateSetting(change))
    }
}
export default mapDispatchToProps
